export default "__VITE_ASSET__SZLwbGze__"